// extracted by mini-css-extract-plugin
export default {"root":"styles_root__geNAQ","textBlock":"styles_textBlock__0rbVV"};